export default "__VITE_ASSET__D4FGR0Zj__"